import InputButton from "Components/UI/Organisms/Plant/Stock/PaperDevolution/DialogDevolution/InputButton"

export const Content = (
  info,
  handleSubmitCode,
  handleChange,
  isLoading,
  data
) => {
  const filteredUsers = data?.filters?.usuario_controlador?.filter(user => user.id !== 0) || []

  return [
    {
      class: "custom", 
      name: "search",
      component: (
        <InputButton
          placeholder="Buscar por dominio o nº v"
          name="search"
          onSubmit={() => handleSubmitCode(info)}
          onKeyUp={(e) => handleChange("search", e.target.value)} 
          value={info.search} 
          resetFormDisabled
          loading={isLoading}
        />
      ),
      sm: 6,
      xs: 12,
    },
    {
      label: "Usuario controlador",
      name: "usuario_controlador",
      options: filteredUsers,
      optionLabel: `options["fullName"]`,
      optionValue: "id",
      sm: 6,
      xs: 12, 
      class: "autocomplete", 
      value: info.usuario_controlador,
      onChange: (e) => {
        handleChange("usuario_controlador", e.id)
      },
    }
  ]
}